
import { ReactComponent as BorderRay } from '../../images/borderRay.svg';
import './borderRay.css';

const BorderRayCircuit = () => {
  return (
     <div className="line-wrapper">
    <div className="svg-container1">
      <BorderRay />
    </div>
    </div>
  );
};

export default BorderRayCircuit;
